import { Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SeriesPieOptions } from 'highcharts';
import { RepartitionChartItem } from 'src/app/shared/model/cybersocxdr/charts/common';

@Component({
  selector: 'app-securitynavigatormanager',
  templateUrl: './securitynavigatormanager.component.html',
  styleUrls: ['./securitynavigatormanager.component.scss'],
})
export class SecuritynavigatormanagerComponent implements OnChanges {
  @Input() data: RepartitionChartItem[] = [];
  graphData: Highcharts.SeriesPieOptions[][] = []; // Graph data generated from the actual data
  categorySum: number = 0;
  dataPercent: number[] = [];

  // Constants specific to this component
  private disabledColor = '#8f8f8f';
  private enabledColors = ['#4BB4E6', '#50BE87', '#FFB4E6', '#A885D8', '#FFD200'];

  constructor(private readonly translate: TranslateService) {}

  ngOnChanges(): void {
    if (!this.data) {
      return;
    }

    // Filter to get relevant data only
    this.categorySum = this.data.reduce((accumulator, currentValue) => accumulator + (currentValue.volume ?? 0), 0);
    this.data = this.data.filter((value) => value.volume > 0).sort((a, b) => (b.volume ?? 0) - (a.volume ?? 0));
    this.data.length = Math.min(this.data.length, 5);

    this.dataPercent = this.data.map((value) =>
      this.categorySum > 0 ? Math.floor(((value.volume ?? 0) * 100) / this.categorySum) : 0
    );

    let offset = 0;

    this.graphData = this.data.map((_, index) => {
      const percent = this.dataPercent[index];
      const returnValue: SeriesPieOptions = {
        type: 'pie',
        data: [
          {
            y: offset,
            color: this.disabledColor,
          },
          {
            y: percent,
            color: this.enabledColors[index % this.enabledColors.length],
          },
          {
            y: 100 - (offset + percent),
            color: this.disabledColor,
          },
        ],
      };
      offset += percent;
      return [returnValue];
    });
  }
}
